<template>
    <div class="wrapH">
        <div class="headerH">
            分类：
            <span
                :class="[{ changeColor: isColor[3] }, headerSpanH]"
                @click="change(3), getData()"
                >全部</span
            >
            <span
                :class="[{ changeColor: isColor[1] }, headerSpanH]"
                @click="change(1), getData()"
                >未开始</span
            >
            <span
                :class="[{ changeColor: isColor[0] }, headerSpanH]"
                @click="change(0), getData()"
                >进行中</span
            >
            <!-- <span :class="[{changeColor:isColor[1]},headerSpanH]" @click="change(1),getData()" >未开始</span> -->
            <span
                :class="[{ changeColor: isColor[2] }, headerSpanH]"
                @click="change(2), getData()"
                >已结束</span
            >
            
        </div>
        <div class="contentH">
            <div class="boxH" v-for="(val, index) in arrOne" :key="index">
                <div class="boxImgH">
                    <img :src="val.cover" :alt="val.offlineCourseTitle" />
                </div>
                <div class="oneH kecheng">课题名称：{{ val.offlineCourseTitle }}</div>
                <div class="twoH">
                    上课日期：<span>{{ val.startTime }}</span>
                </div>
                <div class="threeH">
                    上课时间：<span>{{ val.courseTime }}</span>
                </div>
                <div class="fourH">开课地点：{{ val.courseAdress }}</div>
                <div class="fiveH">主讲教师：{{ val.teacherName }}</div>
                <div class="sixH">
                    剩余名额：{{
                        val.registeredPersonsNum + "/" + val.peopleNumber
                    }}
                </div>
                <div
                    :class="[val.status == 1 && val.isStop!=0 ? buttonH : buttonH2]"
                    @click="go(val,index)"
                    v-show="val.status == 1 || val.status == 3 "
                >
                    {{ message[index] }}
                </div>
                <div class="buttonH2" v-show="val.status == 2">
                    活动未开始
                </div>
                
            </div>
        </div>
		<!-- 弹出框 -->
		<div class="alert" v-show="alertBool">{{alertMessage}}</div>
        <pagebreak :totalPage="totalPage" @changePage="changePage"></pagebreak>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "xxhd",
    data() {
        return {
            arrOne: [],
            isColor: [1, 0, 0, 0],
            headerSpanH: "headerSpanH",
            totalPage: 1,
            status: 1,
            message: [],
            buttonH2: "buttonH2",
            buttonH: "buttonH",
			alertMessage:'',
			alertBool:true,
        };
    },
    methods: {
        //切换页码
        changePage(index) {
            this.getData(index);
            // console.log(index);
        },
        go(val,index) {
            if (val.status == 1) {
                if (this.$store.state.hasLogin) {
                    this.$router.push({
                        name: "hdxq",
                        query: {
                            id: val.id,
							status:this.message[index]
                        }
                    });
                } else {
                    this.$router.push({
                        name: "login"
                    });
                }
            }
        },
        change(x) {
            let arrA = [0, 0, 0, 0];
            arrA[x] = 1;
            this.isColor = arrA;
            this.status = x - 0 + 1;
            if (x == 3) {
                this.status = null;
            }
        },
        getData(x) {
            let data = {
                status: this.status,
                curren: x
            };
            //线下活动
            this.$ajax({
                method: "post",
                url: "homePage/getOfflineActivities",
                data: data,
                success: res => {
                    this.totalPage = Math.ceil(
                        res.message.total / res.message.size
                    );
                    this.arrOne = res.message.records;
                    console.log(this.arrOne)
                    // console.log(this.arrOne);
                    for (var i = 0; i < this.arrOne.length; i++) {
                        
                        if (this.arrOne[i].status == 1) {
							if(this.arrOne[i].isStop == 0){
								this.message[i] = "已报满";
							}else{
								this.message[i] = "立即报名";
							}
                            
                        } else if(this.arrOne[i].status == 2) {
                            this.message[i] = "未开始";
                        } else {
                            this.message[i] = "已结束"; 
                        }
                    }
                },
                error: res => {
                    console.log(res);
                }
            });
        }
    },

    created() {
        this.change(3)
        this.getData();
    }
};
</script>
<style scoped="scoped">
.wrapH {
    width: 1000px;
    overflow: hidden;
    margin: 20px auto;
    min-height: 500px;
}

.headerH {
    margin: 5px 0;
}

.headerSpanH {
    margin-right:30px;
    color: black;
    cursor: pointer;
}

.changeColor {
    color: #6ac0e8;
    margin-right: 30px;
    cursor: pointer;
}

.contentH {
    width: 1000px;
    display: flex;
    /* justify-content: space-between; */
    flex-direction: row;
    flex-wrap: wrap;
}

.boxH {
    width: 242.5px;
    display: inline-block;
    box-sizing: border-box;
    /* border: 1px solid gainsboro; */
    margin-top: 10px;
    margin-right: 10px;
}

.boxH:nth-child(4n) {
    margin-right: 0;
}

.boxImgH {
    width: 100%;
    height: 164.9px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    overflow: hidden;
}

.boxImgH img {
    width: 100%;
    height: 100%;
}

.threeH span {
    font-size: 13px;
}

.buttonH {
    text-align: center;
    background-color: #6ac0e8;
    color: white;
    padding: 5px 10px;
    cursor: pointer;
}
.buttonH2 {
    background-color: #999;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
    color: white;
}
.twoH span {
    font-size: 13px;
}
.kecheng {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/xxhd/xxhd.vue